<!-- 首页 -->
<template>
    <div class="container flex flex-column height-all">
        <!-- 顶部搜索模块 -->
        <div class="searchContainer flex-shrink">
            <baseSearch :searchData="searchData" :isFilterable="true" :isShowExport="isShowExport" @searchClick="searchBtnClick" @exportClick="exportBtnClick"/>
        </div>
        <!-- 主体表格 -->
        <div class="mainTable height-all">
            <basetable tableId="workOrderListTable" tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="productList" :showopera="true" :currentPage="searchDataParam.pageNo" operaWidth="140"
                       :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true"
                       :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick"
                       @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">
                <template v-slot:linkCount="scope">
                    <div class="progressBox" v-if="scope.scope.row.percentage != -1">
                        <el-progress type="circle" :percentage="scope.scope.row.percentage" :width="20" :stroke-width="3" :show-text="false" color="#4A7FF8"></el-progress>
                        <span>{{scope.scope.row.linkCountText}}</span>
                    </div>
                </template>
                <template v-slot:opera="scope">
                    <el-button  plain type="primary" size="small" class="tableOptionBtn" @click="checkWorkOrderDetails(scope.scope,$event)">查看详情</el-button>
                </template>
            </basetable>
        </div>
    </div>
    <!-- 查看详情遮罩层 -->
    <basedialog title="工单详情" :dialogVisible="isShowOrderDetailsCover" dialogWidth="1200" footerBtnType="close" closeText="关闭" @dialogClose="dialogClose" @dialogRightTopClose="dialogClose">
        <template #dialogbody>
            <div class="workOrderDetailsDiv position-relative">
                <div class="detailsInfoDiv">
                    <!-- 工单详情信息 -->
                    <div class="workOrderDetailsInfo">
                        <el-divider content-position="left">工单信息</el-divider>
                        <div style="width: 85%;" v-if="!$utils.isEmpty(workOrderDetailsData)">
                            <div class="workOrderDetailsInfoItem">
                                <span>工单类型：</span>
                                <p v-text="workOrderDetailsData.typeStr || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>订单号：</span>
                                <p v-text="workOrderDetailsData.orderNo || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>订单状态：</span>
                                <p>{{workOrderDetailsData.orderStateStr || "--"}}</p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>生产编码：</span>
                                <p v-text="workOrderDetailsData.productNum || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>生产账号：</span>
                                <p v-text="workOrderDetailsData.productUserName || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>产品名称：</span>
                                <p v-text="workOrderDetailsData.proName || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>问题描述：</span>
                                <p v-text="workOrderDetailsData.qualityProblemDesc || '--'"></p>
                            </div>

                            <div class="workOrderDetailsInfoItem">
                                <span>实付价格：</span>
                                <p>￥{{workOrderDetailsData.showPrice || "--"}}</p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>商品数量：</span>
                                <p v-text="workOrderDetailsData.applyProdCount || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>受理时间：</span>
                                <p v-text="workOrderDetailsData.accTime || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>售后责任方：</span>
                                <p v-text="workOrderDetailsData.shOrderOrderDutyUserTypeName || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>支付时间：</span>
                                <p>{{workOrderDetailsData.payTime || "--"}}</p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>售后单原因：</span>
                                <p v-text="workOrderDetailsData.shOrderOrderRemark || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>生产时间：</span>
                                <p v-text="workOrderDetailsData.productTime || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>售后单号：</span>
                                <p v-text="workOrderDetailsData.shOrderOrderNo || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>发货时间：</span>
                                <p>{{workOrderDetailsData.sendTime || "--"}}</p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>快递公司：</span>
                                <p v-text="workOrderDetailsData.expressName || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem">
                                <span>快递单号：</span>
                                <p v-text="workOrderDetailsData.expressNum || '--'"></p>
                            </div>
                            <div class="workOrderDetailsInfoItem flex align-center justify-start" style="width: auto">
                                <span>收货人地址：</span>
                                <p v-text="workOrderDetailsData.orderAddress || '--'" style="margin-right: 6px"></p>
                                <el-icon class="el-icon-view" @click="getOrderAddressExposure"><View /></el-icon>
                            </div>
                            <div class="workOrderDetailsInfoItem width-all">
                                <span>工单地址：</span>
                                <p v-text="workOrderDetailsData.workOrderAddress || '--'"></p>
                            </div>
                        </div>
                        <div class="workPreviewDiv flex flex-column align-center justify-center">
<!--                            <img :src="workPreviewPicsData[0]" alt="">-->
                            <el-button type="primary" class="previewWorkBtn" @click="previewWorkBtnClick()">预览用户作品</el-button>
                        </div>

                    </div>
                    <!-- 历史工单记录 -->
                    <div class="infoSearchDiv" v-if="historyWorkOrderRecordsArrData.length > 0">
                        <el-divider content-position="left">历史工单记录</el-divider>
                        <div v-for="(item, index) in historyWorkOrderRecordsArrData" style="cursor: pointer;margin: 4px 0" :key="index" @click="openHistoryWorkOrderList(item.workOrderId)">
                            {{item.workOrderNo}}
                        </div>
                    </div>
                    <!-- 用户提交工单详情 -->
                    <div class="infoSearchDiv">
                        <el-divider content-position="left">用户提交工单详情</el-divider>
                        <div class="workOrderDetailsInfoItem width-all">
                            <span>问题描述：</span>
                            <p v-text="workOrderDetailsData.applyDetail || '--'"></p>
                        </div>
                        <div class="workOrderDetailsInfoItem width-all" v-show="problemDescPicsData.length > 0">
                            <span style="width: 160px;">描述图片（点击放大）：</span>
                            <div class="problemDescPicsListDiv">
                                <div class="problemDescPicDiv flex alignCenter justifyCenter" v-for="(item, index) in problemDescPicsData" :key="index">
                                    <el-image :src="item" :initial-index="index" :preview-src-list="problemDescPicsData" :hide-on-click-modal="true"></el-image>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 美印与生产商沟通记录 -->
                    <div class="infoSearchDiv" v-if="queryWorkOrderMsgData.length > 0">
                        <el-divider content-position="left">美印与生产商沟通记录</el-divider>
                        <!-- 回复列表 -->
                        <div class="communicateListDiv">
                            <div class="communicateItemDiv" :class="{'communicateItemRightDiv': item.isSenderMsg == 1}" v-for="(item, index) in queryWorkOrderMsgData" >
                                <div class="submitUserInfoWarpDiv" >
                                    <div class="workOrderSubmitUserHeaderDiv communicateUserHeaderDiv">
                                        <img :src="item.userInfo.headImageUrl" alt="">
                                    </div>
                                    <div class="submitUserInfoDiv">
                                        <p class="userName font-bold width-all">{{item.userInfo.userName}}</p>
                                        <p class="submitTime width-all">{{item.msgDate}}</p>
                                        <p class="telphone width-all" v-if="item.msgType == 'teletext' || item.msgType == 'richText'" v-html="item.msgContent"></p>
                                        <div class="chatMessageImgList" :class="{'floatRight': item.isSenderMsg == 1}" v-if="!$utils.isEmpty(item.imgList)" style=" padding: 0;">
                                            <template v-for="(item,index) in item.imgList" v-key="index">
                                                <el-image :src="item" style="width: 65px;height: 65px;margin: 12px 12px 12px 0;" :preview-src-list="[item]" fit="cover" />
                                            </template>
                                        </div>
                                        <div class="chatMessage userConsultOrderItem"  :class="{'floatRight': item.isSenderMsg == 1}" v-if="item.msgType == 'card'">
                                            <div class="userConsultOrderState">
                                                <div class="userConsultOrderStateTitle flex align-center justify-start">
                                                    <template v-if="item.msgContent.cardType == 'refundSuccess' || item.msgContent.cardType == 'mailSuccess' || item.msgContent.cardType == 'returnSuccess' || item.msgContent.cardType == 'priceSpreadSuccess' || item.msgContent.cardType == 'changeAddrSuccess' || item.msgContent.cardType == 'interceptOrderSuccess' || item.msgContent.cardType == 'shWorkOrderSuccess'">
                                                        <img src="../../static/images/cardSucImg.png" alt="">
                                                        <span class="color_green">{{item.msgContent.cardTitle}}</span>
                                                    </template>
                                                    <template v-else-if="item.msgContent.cardType == 'applyChangeAddr'">
                                                        <img src="../../static/images/cardAddressImg.png" alt="">
                                                        <span>{{item.msgContent.cardTitle}}</span>
                                                    </template>
                                                    <template v-else-if="item.msgContent.cardType == 'applyReturnRefund' || item.msgContent.cardType == 'priceSpread' ">
                                                        <img src="../../static/images/cardWaitImg.png" alt="">
                                                        <span>{{item.msgContent.cardTitle}}</span>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{item.msgContent.cardTitle}}</span>
                                                    </template>
                                                </div>
                                            </div>
                                            <div class="userConsultOrderTitle">
                                                <div class="userConsultOrderTitleNo">{{item.msgContent.cardTime}}</div>
                                            </div>
                                            <div class="userConsultOrderPro">
                                                <div class="userConsultOrderProInfo">
                                                    <!--申请退货退款-->
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.applyReason">
                                                        <span>申请原因：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.applyReason}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.applyDetail">
                                                        <span>申请说明：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.applyDetail}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.applyNum">
                                                        <span>申请数量：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.applyNum}}</div>
                                                    </div>
                                                    <!--同意退货-->
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.returnUserInfo">
                                                        <span>退货地址：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.returnUserInfo}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.returnAddress">
                                                        <span>收件人：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.returnAddress}}</div>
                                                    </div>
                                                    <!--已邮寄-->
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.expressName">
                                                        <span>快递单号：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.expressName}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.expressNum">
                                                        <span>快递公司：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.expressNum}}</div>
                                                    </div>
                                                    <!--退款成功-->
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardType == 'refundSuccess'">
                                                        <div>{{item.msgContent.cardContent}}</div>
                                                    </div>
                                                    <!--转换售后单-->
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.userInfo">
                                                        <span>收件人</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.userInfo}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between"  v-if="item.msgContent.cardContent.address">
                                                        <span>地址</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.address}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.shOrderNo">
                                                        <span>快递单号：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.shOrderNo}}</div>
                                                    </div>
                                                    <!--补差价-->
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.reason">
                                                        <span>原因</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.reason}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between" v-if="item.msgContent.cardContent.price">
                                                        <span>补差价金额：</span><br/>
                                                        <div class="headSubAddress price" >￥{{item.msgContent.cardContent.price}}</div>
                                                    </div>
                                                    <div class="headSubContentDiv flex align-center justify-between"  v-if="item.msgContent.cardContent.detail">
                                                        <span>详情：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.detail}}</div>
                                                    </div>
                                                    <!--申请修改地址-->
                                                    <div class="headSubContentDiv flex align-center justify-between"  v-if="item.msgContent.cardContent.sourceDesc">
                                                        <span>来源说明：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.sourceDesc}}</div>
                                                    </div>
                                                    <!--修改地址成功-->
                                                    <div class="headSubContentDiv flex align-center justify-between"  v-if="item.msgContent.cardContent.desc">
                                                        <span>说明：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.desc}}</div>
                                                    </div>
                                                    <!--申请拦截订单-->
                                                    <div class="headSubContentDiv flex align-center justify-between"  v-if="item.msgContent.cardContent.orderNo">
                                                        <span>订单号：</span><br/>
                                                        <div class="headSubAddress">{{item.msgContent.cardContent.orderNo}}</div>
                                                    </div>
                                                    <!--客服自定义消息-->
                                                    <div class="headSubContentDiv height_auto flex align-center justify-between" v-html="item.msgContent.cardContent"  v-if="item.msgContent.cardType == 'customerCustomizeText'">

                                                    </div>
                                                    <!--上传凭证公用-->
                                                    <div class="headSubContentImgDiv flex align-center justify-between" v-if="item.msgContent.cardContent.applyImgList">
                                                        <span>上传凭证：</span><br/>
                                                        <div class="headSubImgDiv flex align-center justify-end">
                                                            <template v-for="(item2,index2) in item.msgContent.cardContent.applyImgList" :key="index2">
                                                                <img  class="headSubImg" :src="item2" alt="" >
                                                            </template>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 回复美印 -->
                    <div>
                        <el-divider content-position="left">回复美印</el-divider>
                        <wang-editor ref="editorRef" :catchData="catchData" @catchData="handleCatchData" :content="replyMyContent" class="matchDetailsEditor" style="margin-left: 0;"></wang-editor>
                    </div>

                    <!-- 发送给美印 -->
                    <div class="sendToMY" >
                        <el-button type="primary" :loading="submitLoading" class="" @click="submitReplyWorkOrder">发送给美印</el-button>
                        <el-button type="primary" :loading="sureLoading" class="" @click="sureWorkOrder" v-if="workOrderDetailsData.productAlreadyReply == 0">完结确认</el-button>
                    </div>

                </div>
            </div>
            <basedialog title="预览用户作品" :dialogVisible="isShowPreviewWorkCover" dialogWidth="1000" dialogHeight="600" footerBtnType="close" closeText="关闭" @dialogClose="dialogClose2" @dialogRightTopClose="dialogClose2">
                <template #dialogbody>
                    <div class="previewWorkDiv position-relative">
                        <p class="workTotalPages">作品共{{workPreviewPicsData.length}}页</p>
                        <div class="workPreviewListDiv">
                            <div class="workPreviewItemDiv flex alignCenter justifyCenter position-relative" v-for="(item, index) in workPreviewPicsData" :key="index">
                                <!-- <img src="../../static/images/loginLeftImg.png" alt="" class="workPreviewImg"> -->

                                <el-image :src="item" :preview-src-list="workPreviewPicsData" class="workPreviewImg" @click="previewWorkClick"></el-image>
                                <p class="currentWrokPreviewPage position-absolute left-0 bottom-0 width-all">第{{index + 1}}页</p>
                            </div>
                        </div>
                    </div>
                </template>
            </basedialog>
        </template>
    </basedialog>

    <!-- 大图查看作品图片，作品信息遮罩层 -->
    <!--  <div class="workInfoCoverDiv position-fixed right-0 bottom-0" v-if="isShowWorkInfoCoverDiv">
        <div class="workOrderDetailsInfoItem">
          <span>客户昵称：</span>
          <p>{{orderDetailsInfo.userNickName || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>订单号：</span>
          <p>{{orderDetailsInfo.orderNo || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>生产编码：</span>
          <p>{{orderDetailsInfo.productNum || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>收货人姓名：</span>
          <p>{{orderDetailsInfo.addressRealName || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>收货人电话：</span>
          <p>{{orderDetailsInfo.addressPhone || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>收货人地址：</span>
          <p>{{orderDetailsInfo.addressDetail || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>产品名称：</span>
          <p>{{orderDetailsInfo.proName || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>商品数量：</span>
          <p>{{orderDetailsInfo.worksCount || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>订单状态：</span>
          <p>{{orderDetailsInfo.statusStr || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>下单时间：</span>
          <p>{{orderDetailsInfo.makeTime || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>支付时间：</span>
          <p>{{orderDetailsInfo.payTime || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>发货时间：</span>
          <p>{{orderDetailsInfo.sendTime || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>快递公司：</span>
          <p>{{orderDetailsInfo.expressName || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>快递单号：</span>
          <p>{{orderDetailsInfo.expressNum || "&#45;&#45;"}}</p>
        </div>
        <div class="workOrderDetailsInfoItem">
          <span>实付价格：</span>
          <p>￥{{orderDetailsInfo.showPrice || "&#45;&#45;"}}</p>
        </div>
      </div>-->

</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import WangEditor from '@/components/wangEditor'
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";

export default {
    inject: ['$http', '$api', '$utils','$userUtils'],
    name: "orderList",
    components: {
        baseSearch,
        basetable,
        basedialog,
        tableDataSelect,
        WangEditor
    },
    data() {
        return{
            editor: null,  //富文本编辑器
            isShowWorkInfoCoverDiv: false,  //是否显示作品放大图信息遮罩层
            isShowPreviewWorkCover: false,  //是否显示预览作品遮罩层
            workPreviewPicsData: [],  //作品预览图片列表
            workPreviewPicsUrl: "",

            submitLoading: false,
            sureLoading: false,
            replyImgsArr: [],  //回复工单，图片数组
            replyMyContent: "",  //富文本编辑器 -》 回复美印内容
            historyWorkOrderActiveName: "",  //历史工单记录当前激活项
            historyWorkOrderRecordsArrData: [],  //历史工单记录列表数据
            problemDescPicUrl: "",
            problemDescPicsData: [],  //工单详情-》描述图片
            workOrderDetailsData: {},  //工单详情数据

            clearable: true,  //清空输入框
            searchData: [
                {
                    label: "订单号",
                    type: "input",
                    name: "orderNo",
                    value: ""
                },{
                    label: "生产编码",
                    type: "input",
                    name: "productNum",
                    value: ""
                },{
                    label: "生产批次",
                    type: "input",
                    name: "productBatch",
                    value: ""
                },{
                    label: "生产账号",
                    type: "select",
                    name: "productionAccount",
                    options: [],
                },{
                    label: "产品名称",
                    type: "input",
                    name: "productName",
                    value: ""
                },{
                    label: "工单状态",
                    type: "select",
                    name: "status",
                    options: [],
                },{
                    label: "工单类型",
                    type: "select",
                    name: "type",
                    options: [],
                }, {
                    label: "售后单号",
                    type: "input",
                    name: "afterOrderNo",
                    value: ""
                },{
                    label: "售后单负责方",
                    type: "select",
                    name: "afterOrderResponsible",
                    options: [],
                }, {
                    label: "工单处理方状态",
                    type: "select",
                    name: "workHandlerUserStatus",
                    options: [],
                    value: ""
                }, {
                    label: "问题描述",
                    type: "select",
                    name: "questionDescCodes",
                    options: [],
                    isFilterable: true,
                    value: ""
                }, {
                    label: "生产时间",
                    type: "datetimerange",
                    name: "productionTime",
                    value: [],
                }, {
                    label: "受理时间",
                    type: "datetimerange",
                    name: "acceptanceTime",
                    value: [],
                }
            ],
            isLoading: false,
            tableTitle: [
                {
                    label: '工单类型',
                    prop: 'typeStr',
                    width: 120
                }, {
                    label: '问题描述',
                    prop: 'qualityProblemDesc',
                    width: 160
                }, {
                    label: '生产编码',
                    prop: 'productNum',
                    width: 250
                }, {
                    label: '生产批次',
                    prop: 'productBatch',
                    width: 140
                }, {
                    label: '处理状态',
                    prop: 'productAlreadyReply',
                    width: 160
                }, {
                    label: '产品名称',
                    prop: 'proName',
                    width: 250
                }, {
                    label: '订单号',
                    prop: 'orderNo',
                    width: 200
                }, {
                    label: '生产数量',
                    prop: 'worksCount',
                    width: 80
                }, {
                    label: '工单状态',
                    prop: 'statusStr',
                    width: 120
                }, {
                    label: '售后责任方',
                    prop: 'afterOrderResponsible',
                    width: 120
                }, {
                    label: '售后单号',
                    prop: 'afterOrderNo',
                    width: 200
                }, {
                    label: '售后单编码',
                    prop: 'afterProductNum',
                    width: 120
                }, {
                    label: '售后单数量',
                    prop: 'afterOrderCount',
                    width: 100
                }, {
                    label: '售后单原因',
                    prop: 'afterOrderRemark',
                    width: 250
                }, {
                    label: '生产账号',
                    prop: 'productUserName',
                    width: 250
                }, {
                    label: '受理时间',
                    prop: 'accTime',
                    width: 180
                }
            ],
            productList: [],
            orderIds: [],
            total: 0,
            searchDataParam:{
                pageNo:1,
                pageSize:20,
                // orderNo:'',
                // productNum:'',
                // productName:'',
                // status:'',
            },
            isShowOrderDetailsCover: false,  //是否显示订单详情遮罩层
            orderDetailsInfo: {},  //订单详情
            isShowExport:true,
            isViewOptions: [],
            queryWorkOrderMsgData: [],
            orderNo:'',
            isAddressExposure:false,
        }
    },
    watch: {
        // 监听路由变化（包括参数变化）
        $route(to, from) {
            // 路由参数变化时，重新加载数据
            if(this.$route.query.orderNo){
                this.orderNo = this.$route.query.orderNo;
                this.searchData[0].value = this.orderNo;
                this.searchDataParam.orderNo = this.orderNo;

                this.getWorkOrderList2()
            } // 调用数据加载方法
        }
    },
    mounted() {
        //获取生产商账号筛选项
        this.getProductUserOptions();
        //获取问题描述筛选项
        this.queryWorkOrderMergerQuestionDescCodes();

        //公共字典
        this.getCommonDicts("售后_工厂工单状态");
        this.getCommonDicts("售后_工单类型");
        this.getCommonDicts("售后_责任用户类型");
        this.getCommonDicts("售后_处理方处理状态");
        //获取工单列表数据
        // this.getWorkOrderList();
        //监听放大图预览关闭事件
        // document.addEventListener("click", function(e) {
        //   if(e.target.className == "el-icon-close" || e.target.className == "el-image-viewer__mask") {
        //     //点击关闭时，将作品信息隐藏
        //     that.isShowWorkInfoCoverDiv = false;
        //   }
        // })
        if(this.$route.query.orderNo){
            this.orderNo = this.$route.query.orderNo;
            this.searchData[0].value = this.orderNo;
            this.searchDataParam.orderNo = this.orderNo;

            this.getWorkOrderList2()
        }
    },

    methods:{
        /**
         * 获取生产商账号筛选项
         */
        getProductUserOptions() {
            let that = this;
            that.$http.post(that.$api.getProductUserOptionsApi).then(res => {
                if(res.code == 200) {
                    that.searchData[3].options = [];
                    res.data.forEach((item)=>{
                        that.searchData[3].options.push({'label':item.name,'value':item.code})
                    })
                }
            })
        },
        /**
         * 获取生产商账号筛选项
         */
        queryWorkOrderMergerQuestionDescCodes() {
            let that = this;
            that.$http.post(that.$api.queryWorkOrderMergerQuestionDescCodesApi).then(res => {
                if(res.code == 200) {
                    that.searchData[10].options = [];
                    res.data.forEach((item)=>{
                        that.searchData[10].options.push({'label':item.name,'value':item.questionDescCodes})
                    })
                }
            })
        },
        /**
         * 根据类型获取字典数据
         * @param {Object} dictType
         */
        getCommonDicts(dictType) {
           let that = this;
           if(dictType == "售后_工单类型") {
               that.$http.post(that.$api.getCommonDictsApi, {
                   "type": dictType,
                   "sign": ""
               }).then(res => {
                   if(res.code == 200) {
                       that.searchData[6].options = [];
                       res.data.forEach((item,index)=>{
                           console.log(index)
                           if(index < 5){
                               that.searchData[6].options.push({'label':item.name,'value':item.code})
                           }
                       })
                   }
               })
            }else{
               that.$http.post(that.$api.getCommonDictsApi, {
                   "type": dictType,
                   "sign": ""
               }).then(res => {
                   if(res.code == 200) {
                       if(dictType == "售后_工厂工单状态") {
                           that.searchData[5].options = [];
                           res.data.forEach((item)=>{
                               that.searchData[5].options.push({'label':item.name,'value':item.code})
                           })
                       }else if(dictType == "售后_责任用户类型") {
                           that.searchData[8].options = [];
                           res.data.forEach((item)=>{
                               that.searchData[8].options.push({'label':item.name,'value':item.code})
                           })
                       }else if(dictType == "售后_处理方处理状态") {
                           that.searchData[9].options = [];
                           res.data.forEach((item)=>{
                               that.searchData[9].options.push({'label':item.name,'value':item.code})
                           })
                       }
                   }
               })
           }

        },
        /**
         * 获取工单列表数据
         */
        getWorkOrderList() {
            let that = this;
            that.loading = true;
            that.$http.postRaw(that.$api.queryWorkOrderListPageApi, {
                "pageNo": that.searchDataParam.pageNo,
                "pageSize": that.searchDataParam.pageSize,
                "orderNo": that.searchDataParam.orderNo,
                "productNum": that.searchDataParam.productNum,
                "proName": that.searchDataParam.productName,
                "status": that.searchDataParam.status,
                "productBatch": that.searchDataParam.productBatch,
                "productStartTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[0] : "",
                "productEndTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[1] : "",
                "productUserId": that.searchDataParam.productionAccount,
                "type": that.searchDataParam.type,
                "afterOrderResponsible": that.searchDataParam.afterOrderResponsible,
                "workHandlerUserStatus": that.searchDataParam.workHandlerUserStatus,
                "questionDescCodes": that.searchDataParam.questionDescCodes || [],
                "accStartTime": !that.$utils.isEmpty(that.searchDataParam.acceptanceTime) ? that.searchDataParam.acceptanceTime[0] : "",
                "accEndTime": !that.$utils.isEmpty(that.searchDataParam.acceptanceTime) ? that.searchDataParam.acceptanceTime[1] : "",
                "afterOrderNo": that.searchDataParam.afterOrderNo,
            }).then(res => {
                that.loading = false;
                if(res.code == 200) {
                    if(that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
                    that.productList = res.data.list;

                    //遍历数据，重置格式
                    that.productList.forEach((item, index) => {
                        // item.accTime = that.$utils.isEmpty(item.accTime) ? "--" : that.$utils.getDateTime(item.accTime);

                        //重置处理状态的内容
                        if(that.isViewOptions.length > 0) {
                            that.isViewOptions.forEach((viewItem, viewIndex) => {
                                item.produceReadStatusStr = "--";
                                // if(item.productAlreadyReply) {
                                //     if(viewItem.code == item.productAlreadyReply) item.produceReadStatusStr = viewItem.name;
                                // }else{
                                //
                                // }
                            })
                        }
                    })
                }
            })
        },
        /**
         * 获取工单列表数据
         */
        getWorkOrderList2() {
            let that = this;
            that.loading = true;
            that.$http.postRaw(that.$api.queryWorkOrderListPageApi, {
                "pageNo": that.searchDataParam.pageNo,
                "pageSize": that.searchDataParam.pageSize,
                "orderNo": that.searchDataParam.orderNo,
            }).then(res => {
                that.loading = false;
                if(res.code == 200) {
                    if(that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
                    that.productList = res.data.list;

                    //遍历数据，重置格式
                    that.productList.forEach((item, index) => {
                        // item.accTime = that.$utils.isEmpty(item.accTime) ? "--" : that.$utils.getDateTime(item.accTime);

                        //重置处理状态的内容
                        if(that.isViewOptions.length > 0) {
                            that.isViewOptions.forEach((viewItem, viewIndex) => {
                                item.produceReadStatusStr = "--";
                                // if(item.productAlreadyReply) {
                                //     if(viewItem.code == item.productAlreadyReply) item.produceReadStatusStr = viewItem.name;
                                // }else{
                                //
                                // }
                            })
                        }
                    })
                }
            })
        },
        /**
         * 搜索按钮
         */
        searchBtnClick(option){
            let that = this;
            this.searchDataParam = Object.assign(this.searchDataParam,option);
            this.searchDataParam.pageNo = 1;
            this.getWorkOrderList()
            // if(!this.$utils.isEmpty(this.searchDataParam.orderNo) || !this.$utils.isEmpty(this.searchDataParam.productBatch) || !this.$utils.isEmpty(this.searchDataParam.productionAccount) || !this.$utils.isEmpty(this.searchDataParam.productionTime) || !this.$utils.isEmpty(this.searchDataParam.productName) || !this.$utils.isEmpty(this.searchDataParam.productNum) || !this.$utils.isEmpty(this.searchDataParam.status) || !this.$utils.isEmpty(this.searchDataParam.type) || !this.$utils.isEmpty(this.searchDataParam.afterOrderResponsible) || !this.$utils.isEmpty(this.searchDataParam.acceptanceTime)  || !this.$utils.isEmpty(this.searchDataParam.afterOrderNo)){
            //     this.searchDataParam.pageNo = 1;
            //     this.getWorkOrderList()
            // }else{
            //     this.$message.warning('请输入查询条件')
            // }
        },
        /**
         * 设置页码
         */
        currentChange(val){
            this.searchDataParam.pageNo = val;
            this.getWorkOrderList()
        },
        /**
         * 设置页码
         */
        sizeChange(val){
            this.searchDataParam.pageSize = val;
            this.getWorkOrderList()
        },
        /**
         * 查看详情按钮点击事件
         */
        checkWorkOrderDetails(scope,evt) {
            console.log(scope);
            let target = evt.target;
            if(target.nodeName == "SPAN"){
                target = evt.target.parentNode;
            }
            target.blur();
            let that = this;
            that.replyMyContent = '';
            that.submitLoading = false;
            that.workOrderDetailsData = {};
            that.problemDescPicUrl = "";
            that.problemDescPicsData = [];
            that.workPreviewPicsData = [];
            that.historyWorkOrderRecordsArrData = [];
            that.workOrderDetailsData = {
                id:scope.row.workOrderId
            }

            // 获取详情
            this.queryWorkOrderDetail()
        },
        /**
         * 获取详情
         */
        queryWorkOrderDetail(){
            let that = this;
            that.$loading();
            that.$http.post(that.$api.queryWorkOrderInfoDetailApi, {
                "workOrderId": this.workOrderDetailsData.id,
            }).then(res => {
                that.$loading().close();
                if(res.code == 200) {
                    that.workOrderDetailsData = res.data;
                    that.isShowOrderDetailsCover = true;

                    //重置受理工单时间格式
                    // that.workOrderDetailsData.accTime = !that.$utils.isEmpty(that.workOrderDetailsData.accTime) ? that.$utils.getDateTime(that.workOrderDetailsData.accTime) : "--";
                    //遍历数据，获取描述图片数组
                    if(!that.$utils.isEmpty(that.workOrderDetailsData.applyDetailImgList) && that.workOrderDetailsData.applyDetailImgList.length > 0) {
                        // that.problemDescPicUrl = that.workOrderDetailsData.workOrderImgs[0].imgUrl;
                        that.workOrderDetailsData.applyDetailImgList.forEach((item, index) => {
                            that.problemDescPicsData.push(item);
                        })
                    }

                    //遍历数据，重置提交时间、回复图片
                    if(!that.$utils.isEmpty(that.workOrderDetailsData.replies)) {
                        if(that.workOrderDetailsData.replies.length > 0) {
                            that.workOrderDetailsData.replies.forEach((item, index) => {
                                item.workOrderReplyImgsData = [];
                                item.workOrderReplyImgsUrl = "";
                                item.addTime = !that.$utils.isEmpty(item.addTime) ? that.$utils.getDateTime(item.addTime) : "--";
                                item.userImgUrl = that.$utils.isEmpty(item.userImgUrl) ? require("@/static/images/icon_greyHeaderUrl.png") : item.userImgUrl;

                                //重置回复图片样式
                                if(item.imgs.length > 0) {
                                    item.imgs.forEach((itemImg, indexImg) => {
                                        if(indexImg == 0) item.workOrderReplyImgsUrl = itemImg.imgUrl;
                                        item.workOrderReplyImgsData.push(itemImg.imgUrl);
                                    })
                                }
                            })
                        }
                    }

                    //获取作品预览图
                    // that.queryOrderWorksImg();

                    that.queryWorkOrderMsgPage();

                    //获取历史工单
                    that.queryOrderOtherWorkOrderInfo();

                    //刷新工单列表
                    // that.getWorkOrderList();

                    //根据订单号获取订单详情
                    // that.checkOrderDetails();
                }
            })
        },
        getOrderAddressExposure() {
            let that = this;

            if(that.isAddressExposure || that.workOrderDetailsData. isUserAddressDataMask == 0){
                return;
            }
            that.$http.post(that.$api.getOrderAddressExposureApi, {
                "orderId": that.workOrderDetailsData.orderId,
                "orderUserId": that.workOrderDetailsData.orderUserId
            }).then(res => {
                if(res.code == 200) {
                    that.workOrderDetailsData.orderAddress = res.data.addressDetail
                    that.isAddressExposure = true;
                }
            })
        },
        /**
         * 查询消息列表
         */
        queryWorkOrderMsgPage() {
            let that = this;
            that.$http.post(that.$api.queryWorkOrderMsgPageApi,{
                "workOrderId": this.workOrderDetailsData.workOrderId,
            }).then(res => {
                if(res.code == 200) {
                    that.queryWorkOrderMsgData = res.data;
                    that.queryWorkOrderMsgData.forEach(item=>{
                        if(item.msgType == 'card'){
                            item.msgContent = JSON.parse(item.msgContent)
                            if(item.msgContent.cardContent.applyImgList){
                                item.msgContent.cardContent.applyImgList = JSON.parse(item.msgContent.cardContent.applyImgList)
                            }
                        }
                    })
                    console.log(this.queryWorkOrderMsgData)
                }
            })
        },
        ensureImageStyle(html) {
            return html.replace(/<img([^>]*)>/g, (match, group) => {
                if (group.includes('style=')) {
                    return match.replace(/style="([^"]*)"/, (m, style) => {
                        if (!/max-width\s*:\s*10%/.test(style)) {
                            return `style="${style}; max-width:10%;"`
                        }
                        return m;
                    });
                }
                return `<img style="max-width:10%;" ${group}>`;
            });
        },
        /**
         * 查询消息列表
         */
        queryOrderOtherWorkOrderInfo() {
            let that = this;
            that.$http.post(that.$api.queryOrderOtherWorkOrderInfoApi,{
                "workOrderId": this.workOrderDetailsData.workOrderId,
                "orderId": this.workOrderDetailsData.orderId,
                "isChainTester": this.workOrderDetailsData.isChainTester,
            }).then(res => {
                if(res.code == 200) {
                    that.historyWorkOrderRecordsArrData = res.data;
                }
            })
        },
        /**
         * 获取作品预览图
         */
        queryOrderWorksImg() {
            let that = this;
            that.$http.post(that.$api.queryOrderWorksImgApi, {
                "orderId": that.workOrderDetailsData.orderId,
                "orderUserId": that.workOrderDetailsData.orderUserId
            }).then(res => {
                if(res.code == 200) {
                    that.isShowPreviewWorkCover = true;
                    if(res.data.length > 0) {
                        that.workPreviewPicsData = [];
                        res.data.forEach((item, index) => {
                            if(index == 0) that.workPreviewPicsUrl = item.imgUrl;
                            that.workPreviewPicsData.push(item.imgUrl);
                        })
                    }
                }
            })
        },
        /**
         * 获取历史工单
         */
        queryWorkOrderHistoryList() {
            let that = this;
            that.$http.post(that.$api.queryWorkOrderHistoryListApi, {
                "workOrderId": that.workOrderDetailsData.id,
                "orderId": that.workOrderDetailsData.orderId,
                "userId": that.workOrderDetailsData.osUserId
            }).then(res => {
                if(res.code == 200) {
                    that.historyWorkOrderRecordsArrData = res.data;

                    //遍历历史工单数据，重置数据格式
                    if(that.historyWorkOrderRecordsArrData.length > 0) {
                        that.historyWorkOrderRecordsArrData.forEach((item, index) => {
                            //重置提交时间格式
                            item.addTime = !that.$utils.isEmpty(item.addTime) ? that.$utils.getDateTime(item.addTime) : "--";

                            //遍历数据，重置提交时间、回复图片
                            if(!that.$utils.isEmpty(item.replies)) {
                                if(item.replies.length > 0) {
                                    item.replies.forEach((item, index) => {
                                        item.workOrderReplyImgsData = [];
                                        item.workOrderReplyImgsUrl = "";
                                        item.userImgUrl = that.$utils.isEmpty(item.userImgUrl) ? require("@/static/images/icon_greyHeaderUrl.png") : item.userImgUrl;

                                        //重置回复图片样式
                                        if(item.imgs.length > 0) {
                                            item.imgs.forEach((itemImg, indexImg) => {
                                                if(indexImg == 0) item.workOrderReplyImgsUrl = itemImg.imgUrl;
                                                item.workOrderReplyImgsData.push(itemImg.imgUrl);
                                            })
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
        },
        /**
         * 回复工单按钮点击事件
         */
        submitReplyWorkOrder() {
            let that = this;
            //判断是否输入了内容
            if(that.$utils.isEmpty(that.replyMyContent)) {
                that.$message.warning("请输入内容");
                return
            }
            that.replyMyContent = that.replaceImgMaxWidth(that.replyMyContent)
            that.submitLoading = true;

            that.$http.postRaw(that.$api.factorySendRichTextMsgApi, {
                "workOrderId": that.workOrderDetailsData.workOrderId,
                "contentType": 'richText',
                "content":  that.replyMyContent
            }).then(res => {
                that.submitLoading = false;
                if(res.code == 200) {
                    that.$message.success("工单回复成功");
                    that.replyMyContent = '';
                    this.$refs.editorRef.clearContent();
                    that.queryWorkOrderMsgPage();
                    // this.isShowOrderDetailsCover = false;
                    // this.isShowPreviewWorkCover = false;
                }
            }).catch(err => {
                that.submitLoading = false;
            })
        },
        replaceImgMaxWidth(html) {
            return html.replace(
                /(<img[^>]*\sstyle\s*=\s*)(['"])(.*?)\2/gi,
                (match, prefix, quote, style) => {
                    // 添加 max-width 并确保样式结尾有分号
                    const normalizedStyle = style.trim();
                    let newStyle;
                    if (normalizedStyle === '') {
                        newStyle = 'max-width:245px;';
                    } else {
                        newStyle = normalizedStyle.endsWith(';')
                            ? `${normalizedStyle} max-width:245px;`
                            : `${normalizedStyle}; max-width:245px;`;
                    }
                    return `${prefix}${quote}${newStyle}${quote}`;
                }
            );
        },
        /**
         * 完结确认按钮点击事件
         */
        sureWorkOrder() {
            let that = this;
            that.sureLoading = true;
            that.$http.post(that.$api.overWorkOrderApi, {
                "workOrderId": that.workOrderDetailsData.id,
                "userId": that.workOrderDetailsData.osUserId
            }).then(res => {
                that.sureLoading = false;
                if(res.code == 200) {
                    that.$message.success("工单确认成功");

                    this.isShowOrderDetailsCover = false;
                    this.isShowPreviewWorkCover = false;
                    that.getWorkOrderList();
                }
            }).catch(err => {
                that.sureLoading = false;
            })
        },
        /**
         * 工单详情遮罩层-》预览用户作品按钮点击事件
         */
        previewWorkBtnClick() {
            let that = this;
            that.queryOrderWorksImg();

        },
        /**
         * 作品预览查看大图点击事件
         */
        previewWorkClick() {
            let that = this;
            that.isShowWorkInfoCoverDiv = true;
        },
        /**
         * 获取订单详情
         */
        checkOrderDetails() {
            let that = this;
            that.$loading();
            that.$http.post(that.$api.getOrderDetailApi, {
                "orderId": that.workOrderDetailsData.orderId,
                "userId": that.workOrderDetailsData.orderUserId
            }).then(res => {
                that.$loading().close();
                if(res.code == 200) {
                    that.orderDetailsInfo = res.data;
                    that.orderDetailsInfo.makeTime = that.$utils.isEmpty(that.orderDetailsInfo.makeTime) ? "--" : that.$utils.getDateTime(that.orderDetailsInfo.makeTime);
                    that.orderDetailsInfo.payTime = that.$utils.isEmpty(that.orderDetailsInfo.payTime) ? "--" : that.$utils.getDateTime(that.orderDetailsInfo.payTime);
                    that.orderDetailsInfo.checkTime = that.$utils.isEmpty(that.orderDetailsInfo.checkTime) ? "--" : that.$utils.getDateTime(that.orderDetailsInfo.checkTime);
                    that.orderDetailsInfo.sendTime = that.$utils.isEmpty(that.orderDetailsInfo.sendTime) ? "--" : that.$utils.getDateTime(that.orderDetailsInfo.sendTime);
                }
            }).catch(err => {
                that.$loading().close();
            })
        },
        /**
         * 导出
         */
        exportBtnClick(option){
            let that = this;
            this.searchDataParam = Object.assign(this.searchDataParam,option);
            if(!this.$utils.isEmpty(this.searchDataParam.productionTime) || !this.$utils.isEmpty(this.searchDataParam.acceptanceTime)){
                this.searchDataParam.pageNo = 1;

                let searchTimeStart = 0 ;
                let searchTimeEnd = 0 ;
                let intimidateStart = 0 ;
                let intimidateEnd = 0 ;

                if(!that.$utils.isEmpty(this.searchDataParam.productionTime)){
                    searchTimeStart = this.$utils.changeTimestamp(this.searchDataParam.productionTime[0])
                    searchTimeEnd= this.$utils.changeTimestamp(this.searchDataParam.productionTime[1])
                }

                if(!that.$utils.isEmpty(this.searchDataParam.acceptanceTime)){
                    intimidateStart = this.$utils.changeTimestamp(this.searchDataParam.acceptanceTime[0])
                    intimidateEnd= this.$utils.changeTimestamp(this.searchDataParam.acceptanceTime[1])
                }

                if(searchTimeEnd){
                    if ((searchTimeEnd - searchTimeStart) < 3600 * 1000 * 24 * 32 * 3){
                        this.$confirm('是否只导出当前页？', '提示', {
                            confirmButtonText: '是',
                            cancelButtonText: '导出全部',
                            type: 'warning',
                            distinguishCancelAndClose: true,
                            center:true
                        }).then(() => {
                            console.log('导出当前页')
                            that.exportSimplePageData();
                        }).catch((action) => {
                            if (action === 'cancel') {
                                console.log('导出全部')
                                that.exportAllData();
                            }
                        });
                    }else {
                        this.$message.warning("筛选时间不得大于三个月");
                        return;
                    }
                }else if(intimidateEnd){
                    if ( (intimidateEnd - intimidateStart) < 3600 * 1000 * 24 * 32 * 3){
                        this.$confirm('是否只导出当前页？', '提示', {
                            confirmButtonText: '是',
                            cancelButtonText: '导出全部',
                            type: 'warning',
                            distinguishCancelAndClose: true,
                            center:true
                        }).then(() => {
                            console.log('导出当前页')
                            that.exportSimplePageData();
                        }).catch((action) => {
                            if (action === 'cancel') {
                                console.log('导出全部')
                                that.exportAllData();
                            }
                        });
                    }else {
                        this.$message.warning("筛选时间不得大于三个月");
                        return;
                    }
                }
            }else{
                this.$message.warning('请输入查询时间')
            }

        },
        /**
         * 导出当前页
         */
        exportSimplePageData() {
            let that = this;

            //遍历数据，获取当前要导出的订单ID
            that.orderIds = [];
            if(that.productList.length > 0) {
                that.productList.forEach((item, index) => {
                    that.orderIds.push(item.id)
                })
            }

            //导出
            that.exportDyOrder(1);
        },
        /**
         * 导出全部
         */
        exportAllData() {
            let that = this;
            that.orderIds = [];
            that.exportDyOrder(0);
        },
        /**
         * 导出数据
         * @param {Object} type  1：导出当前页     0：导出全部
         */
        exportDyOrder(type) {
            let that = this;
            that.$loading();
            that.$http.postRaw(that.$api.exportWorkOrderListApi, {
                "pageNo": that.searchDataParam.pageNo,
                "pageSize": that.searchDataParam.pageSize,
                "orderNo": that.searchDataParam.orderNo,
                "productNum": that.searchDataParam.productNum,
                "proName": that.searchDataParam.productName,
                "status": that.searchDataParam.status,
                "productBatch": that.searchDataParam.productBatch,
                "productStartTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[0] : "",
                "productEndTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[1] : "",
                "productUserId": that.searchDataParam.productionAccount,
                "type": that.searchDataParam.type,
                "afterOrderResponsible": that.searchDataParam.afterOrderResponsible,
                "workHandlerUserStatus": that.searchDataParam.workHandlerUserStatus,
                "questionDescCodes": that.searchDataParam.questionDescCodes || [],
                "accStartTime": !that.$utils.isEmpty(that.searchDataParam.acceptanceTime) ? that.searchDataParam.acceptanceTime[0] : "",
                "accEndTime": !that.$utils.isEmpty(that.searchDataParam.acceptanceTime) ? that.searchDataParam.acceptanceTime[1] : "",
                "afterOrderNo": that.searchDataParam.afterOrderNo,
                "expFlag": type,
            }).then(res => {
                that.$loading().close();
                if(res.code == 200) {
                    that.$message.success("导出成功，请到我的文件查看");
                }
            })
        },
        /**
         * 关闭订单详情
         */
        dialogClose(){
            this.isShowOrderDetailsCover = false;
            this.isShowPreviewWorkCover = false;
            this.isAddressExposure = false;
        },
        /**
         * 关闭预览
         */
        dialogClose2(){
            this.isShowPreviewWorkCover = false;
        },
        /**
         * 监听富文本编辑器输入内容
         * @param {Object} value
         */
        catchData(value) {
            console.log("触发",value)
            this.replyMyContent = value;
        },

        openHistoryWorkOrderList(workOrderId){
            console.log("aaaaa",workOrderId)
            let that = this;
            that.replyMyContent = '';
            that.submitLoading = false;
            that.workOrderDetailsData = {};
            that.problemDescPicUrl = "";
            that.problemDescPicsData = [];
            that.workPreviewPicsData = [];
            that.historyWorkOrderRecordsArrData = [];
            that.workOrderDetailsData = {
                id: workOrderId
            }

            // 获取详情
            this.queryWorkOrderDetail()
        }
    },
}
</script>
<style scoped>
.mainCont .container{
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 12px;
    box-sizing: border-box;
}
.workOrderReplyImg{
    width: 100px;
    height: 100px;
    background-color: #efefef;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.workInfoCoverDiv{
    width: 400px;
    height: 100%;
    z-index: 3000;
    background: #fff;
    padding: 24px;
    box-sizing: border-box;
}
.workInfoCoverDiv .workOrderDetailsInfoItem span{
    width: 85px;
}
.workInfoCoverDiv .workOrderDetailsInfoItem p{
    width: calc(100% - 85px);
}
.workInfoCoverDiv .workOrderDetailsInfoItem{
    width: 100%;
    margin-top: 0;
    margin-bottom: 10px;
}

.workTotalPages{
    width: 100%;
    text-align: center;
    font-size: 14px;
    margin: 20px 0;
}
.workPreviewListDiv{
    overflow: auto;
    /*padding: 0 25px;*/
    max-height: 620px;
}
.workPreviewItemDiv{
    width: 220px;
    height: 300px;
    border: 1px solid #efefef;
    overflow: hidden;
    margin-right: 15px;
    float: left;
    margin-bottom: 15px;
    cursor: pointer;
    background-color: rgba(0,0,0,0.1);
}
.workPreviewItemDiv:nth-child(4n) {
    margin-right: 0;
}
.workPreviewImg img{
    height: 100%;
    width: auto;
}
.currentWrokPreviewPage{
    height: 32px;
    line-height: 32px;
    background: rgba(0,0,0,0.5);
    font-size: 12px;
    text-align: center;
    color: #fff;
}


.communicateListDiv{
    width: calc(100% - 32px);
    margin-top: 12px;
    padding: 16px;
    background-color: #F7F9FA;
}
.communicateItemDiv{
    overflow: auto;
    margin-bottom: 20px;
}
.communicateUserHeaderDiv{
    width: 60px !important;
    height: 60px !important;
}
.communicateItemRightDiv .communicateUserHeaderDiv{
    float: right;
}
.communicateItemRightDiv .submitUserInfoDiv p{
    text-align: right;
}
.floatRight{
    float: right;
}
.historyWorkOrderResult{
    position: absolute;
    right: 35px;
    color: #009688;
}
.redColor{
    color: #E02020;
}
.problemDescPicsListDiv{
    width: calc(100% - 160px);
    float: left;
    overflow: auto;
}
.problemDescPicDiv{
    width: 100px;
    height: 100px;
    overflow: hidden;
    background-color: #efefef;
    margin-right: 12px;
    float: left;
}
.problemDescPicDiv img{
    width: 100%;
}
.sendToMY{
    margin: 50px 0 20px;
    text-align: center;
}
/* 工单详情遮罩层 */
.workOrderDetailsCover, .previewWorkCover{
    background: rgba(0,0,0,0.5);
}
.workOrderDetailsDiv, .previewWorkDiv{
    width: 100%;
    background: #fff;
    padding: 10px;
    border-radius: 5px;
}
.coverTitle{
    text-align: center;
    font-size: 16px;
    color: #000;
    line-height: 40px;
}
.closeCoverDiv{
    width: 30px;
    height: 30px;
    top: 15px;
    right: 15px;
    cursor: pointer;
}
.closeCoverDiv img{
    width: 20px;
}
.detailsInfoDiv{
    /*max-height: 800px;*/
    /*overflow-y: scroll;*/
    /*padding: 0 20px 30px;*/
    box-sizing: border-box;
}
.workOrderDetailsInfo, .infoSearchDiv{
    overflow: auto;
    font-size: 13px;
    margin-bottom: 15px;
}
.workOrderDetailsInfoItem{
    width: 50%;
    margin-top: 12px;
    overflow: auto;
    padding-right: 16px;
    box-sizing: border-box;
    float: left;
}
.workOrderDetailsInfoItem span{
    width: 110px;
    display: inline-block;
    float: left;
    color: #666;
    line-height: 22px;
    font-size: 14px;
}
.workOrderDetailsInfoItem p{
    width: calc(100% - 110px);
    font-size: 13px;
    float: left;
    word-break: break-all;
    line-height: 22px;
}
.workPreviewDiv{
    width: 15%;
    height: auto;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
}
.workPreviewDiv img{
    width: 100%;
}
.workPreviewDiv .previewWorkBtn{
    /* margin-left: 16px; */
    margin-top: 10px;
}
.workPreviewInit{
    width: 72%;
    height: auto;
}
.workOrderInfoDiv{
    overflow: auto;
    margin-bottom: 20px;
}
.workOrderSubmitUserHeaderDiv{
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #efefef;
    float: left;
}
.workOrderSubmitUserHeaderDiv img{
    width: 100%;
}
.submitUserInfoWarpDiv{
    overflow: auto;
}
.submitUserInfoDiv{
    float: left;
    width: calc(100% - 92px);
    height: 100%;
    margin-left: 12px;
}
.userName, .submitTime, .telphone{
    font-size: 12px !important;
    columns: #333;
    line-height: 25px;
}
.telphone span{
    font-size: 12px !important;
}
.telphone img{
    max-width: 10% !important;
}

.chatName{
    width: 50%;
}
.chatName span{
    font-weight: 600;
    color: #070B17;
    font-size: 15px;
}
.chat{
    width: 35%;
    margin-left: 12px;
}
.chat img{
    width: 16px;
    margin-right: 4px;
}
.chatMessage{
    margin-top: 8px;
    padding: 12px;
    max-width: 50%;
    background: #FFFFFF;
    border-radius: 11px 11px 11px 0;
    word-wrap: break-word;
}
.chatMessageImgList{
    max-width: 50%;
}
.chatMessageDiv{
    margin-bottom: 16px;
}
.chatNameRight{
    width: 100%;
    text-align: right;
}
.chatNameRight span{
    font-weight: 600;
    color: #070B17;
    font-size: 15px;
}
.chatRight{
    width: 20%;
    margin-left: 12px;
}
.chatRight img{
    width: 16px;
    margin-right: 4px;
}
.chatMessageRightDiv{
    width: 100%;
}
.chatMessageRight{
    text-align: right;
    margin-top: 8px;
    padding: 12px;
    max-width: 50%;
    background: #FFFFFF;
    border-radius: 11px 11px 0 11px;
    word-wrap: break-word;
}
.userConsultOrderItem{
    width: 300px;
}
.userConsultOrderStateTitle{
    font-weight: 600;
    margin-bottom: 6px;
}
.userConsultOrderTitle{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.userConsultOrderStateTitle img{
    width: 15px;
    margin-right: 6px;
}
.userConsultOrderTitleNo{
    color: #999999;
}
.userConsultOrderTitle span{
    color: #24D83B;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    background-color: #E7FAEA;
    border-radius: 3px;
    padding: 0 10px;
}
.userConsultOrderPro{
    background: #F3F6FD;
    border-radius: 7px;
    overflow: hidden;
    margin-top: 6px;
}
.userConsultOrderProInfo{
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    overflow: hidden;
    padding: 10px 10px;
}
.userConsultOrderProInfo .headSubContentDiv{
    width: calc(100% - 20px);
    height: revert;
    margin-bottom: 10px;
}
.userConsultOrderProInfo .headSubContentDiv:last-of-type{
    margin-bottom: 0;
}
.headSubContentDiv .price{
    color: #FF0000;
    font-weight: 600;
}
.height_auto{
    height: auto!important;
}
.color_green{
    color: #52C41A;
}
.headSubContentImgDiv{
    width: 48%;
    float: left;
    height: 50px;
    margin-bottom: 12px;
    color: #666666;
}
.userConsultOrderProInfo .headSubContentImgDiv{
    width: calc(100% - 20px);
    margin-bottom: 10px;
}
.userConsultOrderProInfo .headSubContentImgDiv:last-of-type{
    margin-bottom: 0;
}
.headSubImgDiv{
    width: 70%;
}
.headSubImg{
    width: 45px;
    max-height: 48px;
    margin-left: 10px;
}
</style>
<style>
.el-divider__text{
    font-weight: bold;
}
.el-collapse-item__header{
    position: relative;
}
.workOrderReplyImg .el-image__inner{
    width: 100% !important;
    height: auto !important;
}
.el-table .highlight{
    background-color: rgba(255, 157, 77, 0.3);
}
.el-image-viewer__wrapper{
    z-index: 99999!important;
}

.telphone span{
    font-size: 12px !important;
}
.telphone img{
    max-width: 20% !important;
}
.w-e-text-container,.w-e-toolbar{
    z-index: 99!important;
}
.headSubAddress{
    width: 70%;
}
.el-icon-view{
    cursor: pointer;
}
</style>